// Normalize base URL so route joins like `endpoint + "remove-from-cart/"` never
// become `https://api.example.comremove-from-cart/` when env omits a trailing slash.
const raw = (process.env.REACT_APP_BASE_URL || "").trim();
const endpoint = raw ? `${raw.replace(/\/+$/, "")}/` : "";

export default endpoint;
//production url - https://bk.techvantoacademy.com/
//stage url - https://stagbk.techvantoacademy.com/
//http://localhost:5000/